import { Pencil, Trash2 } from 'lucide-react';
import { Button, Card, CardBody, Pill } from '@/shared/components';
import type { ParkingSpotResponse } from '@/shared/api';

interface Props {
  spot: ParkingSpotResponse;
  currency: string;
  onEdit?: () => void;
  onDelete?: () => void;
}

export function ParkingSpotCard({ spot, currency, onEdit, onDelete }: Props) {
  const price = new Intl.NumberFormat('de-DE', { style: 'currency', currency }).format(spot.price);
  return (
    <Card>
      <CardBody className="flex items-center justify-between gap-4 py-5">
        <div>
          <div className="flex items-center gap-2">
            <h3 className="text-ink font-serif text-xl">{spot.label}</h3>
            <Pill variant={spot.isActive ? 'on' : 'outline'} size="sm">
              {spot.isActive ? 'Aktiv' : 'Inaktiv'}
            </Pill>
          </div>
          <p className="text-ink-soft mt-1 text-sm">
            {price} {spot.priceUnit === 'PerNight' ? 'pro Nacht' : 'pro Aufenthalt'}
          </p>
        </div>
        {(onEdit || onDelete) && (
          <div className="flex gap-1">
            {onEdit && (
              <Button size="icon" aria-label={`${spot.label} bearbeiten`} onClick={onEdit}>
                <Pencil size={15} />
              </Button>
            )}
            {onDelete && (
              <Button size="icon" aria-label={`${spot.label} entfernen`} onClick={onDelete}>
                <Trash2 size={15} />
              </Button>
            )}
          </div>
        )}
      </CardBody>
    </Card>
  );
}
